import { render, staticRenderFns } from "./UploadAttendance.vue?vue&type=template&id=70724715&scoped=true"
import script from "./UploadAttendance.vue?vue&type=script&lang=js"
export * from "./UploadAttendance.vue?vue&type=script&lang=js"
import style0 from "./UploadAttendance.vue?vue&type=style&index=0&id=70724715&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70724715",
  null
  
)

export default component.exports